import {
	BettingOffer,
	Event,
	KeyOffer,
	PageableOfferResponse,
} from "@gp/models";
import { EventResultHistoryResponse } from "@api-types/offer/offer-history/EventResultHistoryResponse";
import { buildHistoryEventDefaults } from "./historyEventDefaults";

/**
 * Remaps a JSON object from the new source structure (Results history api endpoint) to the target structure (Offer/data endpoint).
 * @param input The source data object
 * @returns A new object mapped to the target structure.
 */
export function eventResultsHistoryMapper(
	input: EventResultHistoryResponse
): PageableOfferResponse {
	const sourceEvent = input.offers[0].event;
	const lookups = input.lookups;

	let sportIdFromLookup: string | null = null;
	if (lookups && lookups.categories && sourceEvent.sportCategoryId) {
		const category = lookups.categories[sourceEvent.sportCategoryId];
		if (category && category.sportId) {
			sportIdFromLookup = category.sportId;
		}
	}

	const mappedEvent: Event = {
		...buildHistoryEventDefaults(),
		id: sourceEvent.id,
		sportCategoryId: sourceEvent.sportCategoryId,
		startTime: sourceEvent.startTime,
		teamOneId: sourceEvent.teamOneId,
		teamTwoId: sourceEvent.teamTwoId,
		tournamentId: sourceEvent.tournamentId,
		sportId: sportIdFromLookup || sourceEvent.sportId,
		totalOfferCount: sourceEvent.totalOfferCount,
		//@ts-ignore
		result: sourceEvent.result,
		source: sourceEvent.source as unknown as Event["source"],
	};

	// --- Offer Transformation ---
	const mappedOffers = input.offers[0].keys.map((sourceOffer, index) => {
		const generatedKeyId = `generated-key-${index}-${sourceOffer.key.bettingTypeId}`;

		const mappedOutcomes: BettingOffer[] = sourceOffer.offers.map(
			(sourceOutcome, outcomeIndex) => {
				const generatedOutcomeId = `generated-outcome-${index}-${outcomeIndex}`;
				return {
					id: sourceOutcome.id || generatedOutcomeId,
					specifier: sourceOffer.key.specifier,
					tip: sourceOutcome.tip,
					status: sourceOutcome.status,
					value: 0,
					playerId: sourceOutcome.playerId,
					teamId: sourceOutcome.teamId,
					betBuilder: false,
					displayTip: sourceOutcome.displayTip || "",
				};
			}
		);

		const mappedOffer: KeyOffer = {
			bettingTypeId: sourceOffer.key.bettingTypeId,
			keyId: sourceOffer.key.id || generatedKeyId,
			key: {
				bettingTypeId: sourceOffer.key.bettingTypeId,
				id: sourceOffer.key.id || generatedKeyId,
				specifier: sourceOffer.key.specifier,
				betBuilder: false,
			},
			offers: mappedOutcomes,
		};
		return mappedOffer;
	});

	const remappedData: PageableOfferResponse = {
		version: 1,
		lookup: input.lookups,
		offer: [
			{
				event: mappedEvent,
				eventId: mappedEvent.id,
				offers: mappedOffers,
			},
		],
		pageNumber: 1,
		pageSize: 1,
		totalNumberOfItems: 0,
		startingVersion: 0,
	};

	return remappedData;
}
